import { isUndefined } from 'utils/tsHelpers';
import { isEpochDate } from 'utils/validateDate';

/**
 * util used to update the date value when parsing
 */
export const updateDateToParse = (date?: string) => {
  if (isUndefined(date)) return;
  if (isEpochDate(date)) return parseInt(date, 10);
  else return date;
};
